export enum RoleEnum {
  None = 0,
  InstitutionAdmin = 1,
  CASAdmin = 2,
  ASOOAdmin = 3,
  Helpdesk = 4,
  InstitutionDirector = 5,
  ASOOManager = 6,
  CASManager = 7  ,
  ASOOOffice = 8,
  CASOffice = 9,
}
